import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import PortalShell from '@components/PortalShell';
import Login          from '@pages/Login';
import SetPassword    from '@pages/SetPassword';
import ForgotPassword from '@pages/ForgotPassword';
import Home        from '@pages/Home';
import MyProfile   from '@pages/MyProfile';
import MyDocuments from '@pages/MyDocuments';
import Assistant   from '@pages/Assistant';
import Tickets     from '@pages/Tickets';
import Comms       from '@pages/Comms';
import Faq         from '@pages/Faq';
import Privacy     from '@pages/Privacy';
import MyUniform   from '@pages/logistics/MyUniform';
import MyAssets    from '@pages/logistics/MyAssets';
import MyRequests  from '@pages/logistics/MyRequests';
import NewRequest  from '@pages/logistics/NewRequest';
import RequestDetail from '@pages/logistics/RequestDetail';
import Confirmations from '@pages/logistics/Confirmations';
import Training     from '@pages/Training';
import Absences     from '@pages/Absences';
import ApprovalInbox from '@pages/ApprovalInbox';
import EntitlementConfirm from '@pages/EntitlementConfirm';

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login"        element={<Login />} />
      <Route path="/forgot"       element={<ForgotPassword />} />
      <Route path="/set-password" element={<SetPassword />} />

      <Route element={<ProtectedRoute><PortalShell /></ProtectedRoute>}>
        <Route path="/"          element={<Home />} />
        <Route path="/profile"   element={<MyProfile />} />
        <Route path="/documents" element={<MyDocuments />} />
        <Route path="/assistant" element={<Assistant />} />
        <Route path="/tickets"   element={<Tickets />} />
        <Route path="/comms"     element={<Comms />} />
        <Route path="/faq"       element={<Faq />} />
        <Route path="/uniform"   element={<MyUniform />} />
        <Route path="/assets"    element={<MyAssets />} />
        <Route path="/requests"  element={<MyRequests />} />
        <Route path="/requests/new" element={<NewRequest />} />
        <Route path="/requests/:id" element={<RequestDetail />} />
        <Route path="/confirmations" element={<Confirmations />} />
        <Route path="/training"  element={<Training />} />
        <Route path="/absences"  element={<Absences />} />
        <Route path="/approvals" element={<ApprovalInbox />} />
        <Route path="/approvals/entitlements" element={<EntitlementConfirm />} />
        <Route path="/gdpr"      element={<Privacy />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
